module.exports = __webpack_public_path__ + "img/vipIcon.b3218861.png";